export default [
  { id: 1, description: "PÂNICO", type: "select-boolean" },
  { id: 2, description: "ENTRADA 2", type: "select-boolean" },
  { id: 3, description: "ENTRADA 3", type: "select-boolean" },
  { id: 9, description: "IGNIÇÃO", type: "select-boolean" },
  { id: 13, description: "VOLTAGEM MENOR QUE", type: "number" },
  { id: 36, description: "VELOCIDADE MAIOR QUE", type: "number" },
  { id: 37, description: "VELOCIDADE MENOR QUE", type: "number" },
  { id: 38, description: "PONTO MAIS PRÓXIMO", type: "select" },
  { id: 45, description: "PONTO <> DIFERENTE", type: "select" },
  { id: 16, description: "FORA DA ÁREA", type: "select" },
  { id: "16.1", description: "DENTRO DA ÁREA", type: "select" },
  { id: 106, description: "MOTIVO DE TRANSMISSÃO", type: "number" },
  { id: 1000, description: "HORÁRIO MAIOR QUE", type: "time" },
  { id: 1001, description: "HORÁRIO MENOR QUE", type: "time" },
  { id: 1002, description: "HORÁRIO DENTRO DO INTERVALO", type: "time" },
  { id: 1003, description: "HORÁRIO FORA DO INTERVALO", type: "time" },
  { id: 1004, description: "DIAS DA SEMANA", type: "days" },
  { id: 1006, description: "FORA DE ROTA", type: "number" },
  { id: 1007, description: "FORA DE ROTA TEMPORÁRIA", type: "number" },
];
